export const CommonString = {
  NOT_SPECIFIED: 'Not specified',
  VEHICLE_NOT_SPECIFIED: 'Vehicle not specified',
  DESCRIPTION_NOT_SPECIFIED: 'Vehicle description is not specified',
  FEATURED_NOT_SPECIFIED: 'Featured specification is not specified',
  TARGET_NOT_SPECIFIED: 'Publish target is not specified',
  HISTORY_NOT_SPECIFIED: 'There is No Service History for this vehicle',
};
